<template>
  <div class="big_box">
    <report-table-children
      :api-config="apiConfig"
      :date-field="'billDateRange'"
      data-key="data"
      :show-pagination="true"
      report-key="PurcDailyRpt"
      filterMode="drawer"
    />
  </div>
</template>

<script>
import { apiPurcDailyRpt, apiPurcDailyRptPull, apiPurcDailyRptExport } from '@/request/api';

export default {
  name: 'PurcDailyRpt',
  data() {
    return {
      apiConfig: {
        pull: apiPurcDailyRptPull,
        getData: apiPurcDailyRpt,
        exportData: apiPurcDailyRptExport
      }
    };
  }
};
</script>

<style  lang="scss" scoped>
</style>
